import { requestGet } from '@/common/request';
import { useState, useEffect, useMemo } from 'react';
import { message } from 'antd';

export interface erpRes {
  ret: string;
  msg: string;
  data: { data: number };
  systemTime: number;
}

//是否是京喜erp
export async function erp(): Promise<erpRes> {
  return await requestGet('/generic/mac/common/dept/jx/erp');
}

export function useIsJingxiErp() {
  const [loading, setLoading] = useState(true);
  const [state, setState] = useState<{ data: number }>();
  useEffect(() => {
    let didMount = true;
    setLoading(true);
    erp()
      .then((res) => {
        if (!didMount) return;

        const { ret, data } = res || {};
        if (ret !== '0' || !data) {
          message.error('网络异常请稍候~');
          setLoading(false);
          return;
        } else {
          setState(data);
          setLoading(false);
        }
      })
      .catch((ex) => {
        setLoading(false);
        console.error(ex);
      });

    return () => {
      didMount = false;
    };
  }, []);

  const data = useMemo(() => {
    return { loading, data: state };
  }, [loading, state]);

  return [data];
}
